<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content not-found-container">
      <div class="not-found-content">
        <!-- <img src="@/assets/images/404.svg" alt="404 Not Found" class="not-found-image" /> -->
        <h1 class="not-found-title">Oops! Page Not Found</h1>
        <p class="not-found-message">
          The page you are looking for might have been removed or temporarily unavailable.
        </p>
        <router-link to="/" class="back-home-button">Go to Homepage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Page Not Found",
    };
  },
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  text-align: center;
}

.not-found-content {
  max-width: 500px;
  padding: 20px;
}

.not-found-image {
  width: 100%;
  max-width: 300px;
  margin-bottom: 20px;
}

.not-found-title {
  font-size: 2rem;
  font-weight: bold;
  color: #ff4d4d;
  margin-bottom: 10px;
}

.not-found-message {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 20px;
}

.back-home-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1rem;
  transition: 0.3s;
}

.back-home-button:hover {
  background-color: #0056b3;
}
</style>

